/**
 * SRN Homes — Theme JavaScript
 * Handles: header mobile drawer, dropdown toggles, FAQ accordion, scroll animations
 */

(function() {
  'use strict';

  // ===== Mobile Drawer Toggle =====
  var toggles = document.querySelectorAll('.site-header__toggle');
  toggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var drawer = document.getElementById('SiteDrawer');
      if (!drawer) return;
      var isOpen = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // ===== Mobile Drawer Dropdown Toggles =====
  var drawerItems = document.querySelectorAll('.site-drawer__item.has-dropdown');
  drawerItems.forEach(function(item) {
    var link = item.querySelector('.site-drawer__link');
    if (link) {
      link.addEventListener('click', function(e) {
        // If the item has a dropdown, toggle it on click
        var sublist = item.querySelector('.site-drawer__sublist');
        if (sublist) {
          e.preventDefault();
          item.classList.toggle('is-open');
        }
      });
    }
  });

  // ===== FAQ Accordion =====
  var faqToggles = document.querySelectorAll('[data-faq-toggle]');
  faqToggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.srn-faq-item');
      if (!item) return;

      var isOpen = item.classList.contains('is-open');
      var expanded = !isOpen;

      // Optional: close other FAQ items in the same list
      var parent = item.closest('.srn-faq-list');
      if (parent) {
        parent.querySelectorAll('.srn-faq-item.is-open').forEach(function(openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            var openBtn = openItem.querySelector('[data-faq-toggle]');
            if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
            var openAnswer = openItem.querySelector('.srn-faq-answer');
            if (openAnswer) openAnswer.setAttribute('aria-hidden', 'true');
          }
        });
      }

      item.classList.toggle('is-open', expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var answer = item.querySelector('.srn-faq-answer');
      if (answer) answer.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    });
  });

  // ===== Scroll Fade-In (fallback for browsers without scroll-driven animations) =====
  if (!CSS.supports || !CSS.supports('animation-timeline', 'scroll()')) {
    var fadeEls = document.querySelectorAll('.srn-fade-in');
    if (fadeEls.length > 0 && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      fadeEls.forEach(function(el) {
        el.style.opacity = '0';
        el.style.transition = 'opacity 0.6s ease';
        observer.observe(el);
      });
    }
  }

})();
